import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import {
  MollyWhitelabelCustomerActions,
  MollyWhitelabelCustomerKYCDocumentsActions,
  MollyWhitelabelCustomerLiveInfoActions,
  MollyWhitelabelCustomerNetTransfersActions,
  MollyWhitelabelCustomerPLActions,
  MollyWhitelabelCustomerSummariesActions,
  MollyWhitelabelKYCDocumentsActions,
} from './actions';
import {
  MollyWhitelabelCustomerKYCDocumentsState,
  MollyWhitelabelCustomerLiveInfoState,
  MollyWhitelabelCustomerNetTransfersState,
  MollyWhitelabelCustomerPLState,
  MollyWhitelabelCustomerState,
  MollyWhitelabelCustomerSummariesState,
  MollyWhitelabelKYCDocumentsState,
} from './states';

// #region MollyWhitelabelCustomer
export const mollyWhitelabelCustomerRecipe: Recipe<
  MollyWhitelabelCustomerState,
  MollyWhitelabelCustomerActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/customer/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/customer/finished':
      draft.pending = false;
      draft.customer = action.customer;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const mollyWhitelabelCustomerSummariesRecipe: Recipe<
  MollyWhitelabelCustomerSummariesState,
  MollyWhitelabelCustomerSummariesActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/customers/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/customers/finished':
      draft.pending = false;
      draft.customers = action.customers;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region MollyWhitelabelCustomerKYCDocuments
export const mollyWhitelabelCustomerKYCDocumentsRecipe: Recipe<
  MollyWhitelabelCustomerKYCDocumentsState,
  MollyWhitelabelCustomerKYCDocumentsActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/customer/kyc/documents/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/customer/kyc/documents/finished':
      draft.pending = false;
      draft.documents = action.documents;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const mollyWhitelabelKYCDocumentsRecipe: Recipe<
  MollyWhitelabelKYCDocumentsState,
  MollyWhitelabelKYCDocumentsActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/kyc/documents/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/kyc/documents/finished':
      draft.pending = false;
      draft.documents = action.documents;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region MollyWhitelabelCustomerLiveInfo
export const mollyWhitelabelCustomerLiveInfoRecipe: Recipe<
  MollyWhitelabelCustomerLiveInfoState,
  MollyWhitelabelCustomerLiveInfoActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/customer/live_info/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/customer/live_info/finished':
      draft.pending = false;
      draft.liveInfo = action.liveInfo;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region MollyWhitelabelCustomerPL
export const mollyWhitelabelCustomerPLRecipe: Recipe<
  MollyWhitelabelCustomerPLState,
  MollyWhitelabelCustomerPLActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/customer/pl/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/customer/pl/finished':
      draft.pending = false;
      draft.pl = action.pl;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion

// #region MollyWhitelabelCustomerPL
export const mollyWhitelabelCustomerNetTransfersRecipe: Recipe<
  MollyWhitelabelCustomerNetTransfersState,
  MollyWhitelabelCustomerNetTransfersActions
> = (draft, action) => {
  switch (action.type) {
    case 'molly_whitelabel/customer/net_transfers/started':
      draft.pending = true;
      return;

    case 'molly_whitelabel/customer/net_transfers/finished':
      draft.pending = false;
      draft.netTransfers = action.netTransfers;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion
